import { useQuery } from "@tanstack/react-query";
import { MessageCircle, Mail, Instagram, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { useMeta, waLink } from "@/lib/site";
import { Overline, Reveal } from "@/components/Reveal";

export default function ContactPage() {
  useMeta("Contact", "Contact Bonheur Eternal — WhatsApp +92 333 2644998, email hello.bonheureternal@gmail.com. Delivering all over Pakistan.");
  const { data: c } = useQuery({ queryKey: ["contact"], queryFn: async () => (await api.get("/contact")).data });

  const rows = [
    { Icon: MessageCircle, label: "WhatsApp", value: c?.whatsapp_display || "+92 333 2644998", href: waLink("Hello Bonheur Eternal"), testid: "contact-whatsapp", note: "Fastest — orders, questions, wholesale. Replies within hours." },
    { Icon: Mail, label: "Email", value: c?.email || "hello.bonheureternal@gmail.com", href: `mailto:${c?.email || "hello.bonheureternal@gmail.com"}`, testid: "contact-email", note: "Press, partnerships and anything that deserves a longer reply." },
    { Icon: Instagram, label: "Instagram", value: c?.instagram || "@bonheureternal", href: `https://instagram.com/${(c?.instagram || "@bonheureternal").replace("@", "")}`, testid: "contact-instagram", note: "The house, in pictures." },
  ];

  return (
    <div className="pt-32 md:pt-44 pb-32 px-5 md:px-8 max-w-4xl mx-auto">
      <Reveal>
        <Overline>Contact</Overline>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2B2118] mt-4 tracking-tight">One message away.</h1>
        <p className="mt-6 text-[#5A4C3C] leading-loose max-w-xl">
          Whether you are choosing a first bottle, following up on an order, or writing about the house — we read everything, and we answer.
        </p>
      </Reveal>
      <div className="mt-20 divide-y divide-[#2B2118]/[0.06] border-y border-[#2B2118]/[0.06]">
        {rows.map((r, i) => (
          <Reveal key={r.label} delay={i * 0.08}>
            <a href={r.href} target="_blank" rel="noopener noreferrer" data-testid={r.testid} className="group grid md:grid-cols-12 gap-4 py-10 items-center">
              <div className="md:col-span-3 flex items-center gap-4">
                <r.Icon size={18} strokeWidth={1.25} className="text-[#8F6B3A]" />
                <span className="text-[11px] tracking-[0.3em] uppercase text-[#6E6151]">{r.label}</span>
              </div>
              <p className="md:col-span-4 font-display text-xl text-[#2B2118] group-hover:text-[#8F6B3A] transition-colors">{r.value}</p>
              <p className="md:col-span-5 text-sm text-[#6E6151] leading-relaxed">{r.note}</p>
            </a>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-16 flex items-center gap-4 text-sm text-[#6E6151]">
        <MapPin size={16} strokeWidth={1.25} className="text-[#8F6B3A]" />
        <span>{c?.region || "Delivering all over Pakistan"}</span>
      </Reveal>
    </div>
  );
}
